import { lang } from '../../assets/lang'
import { delayHtml } from '../../data/modal/delayHtml'

export const otnHtml =
'<div class="form-group text-left mt-2">' +
  '<label for="otn-otn-title">' + lang.otn_html_label_title + '</label>' +
  '<input type="text" id="otn-otn-title" class="form-control">' +
'</div>' +

'<div class="form-group text-left mt-2">' +
  '<label for="otn-otn-postbackId">' + lang.otn_html_label_postback_id + '</label>' +
  '<select id="otn-otn-postbackId" class="form-control select2"></select>' +
'</div>' +

// Adds html for delay system
delayHtml
